<template>
  <div class="upgrade-plan-page py-8 px-4 px-md-6">

    <v-col cols="12" align-self="center" class="header-container mb-12">
      <div class="d-flex align-start flex-column">
        <div class="d-flex align-center">
          <v-img class="mr-2" :src="require('@/assets/icons/admin+/workspace_premium.svg')" width="24" height="24"
            max-width="24" contain />
          <span class="font-roboto font-weight-medium text-h5">{{ $t("message.admin_plus_upgrade_now") }}</span>
        </div>
      </div>
    </v-col>


    <div class="mx-auto" style="max-width: 960px">


      <h1 class="font-roboto text-h4 text-md-h3 font-weight-regular text-center mb-3 plusGreyDarken4--text">
        {{ $t("message.admin_plus_upgrade_select_plan_title") }}
      </h1>
      <p class="font-roboto text-body-1 text-center mb-8 plusGreyDarken1--text">
        {{ planSubtitle }}
      </p>

      <div class="d-flex justify-center mb-4 ">
        <div class="billing-pill d-inline-flex align-center pa-2 rounded-pill">
          <v-btn elevation="1"
            :class="['billing-pill-btn font-roboto text-body-2 font-weight-medium rounded-pill', { 'billing-pill-btn--active': !billingYearly }]"
            @click="billingYearly = false">
            {{ $t("message.admin_plus_upgrade_billing_monthly") }}
          </v-btn>
          <v-btn elevation="1"
            :class="['billing-pill-btn font-roboto text-body-2 font-weight-medium rounded-pill', { 'billing-pill-btn--active': billingYearly }]"
            @click="billingYearly = true">
            <span>{{ $t("message.admin_plus_upgrade_billing_yearly") }}</span>

            <v-chip class="ml-2 px-1 rounded-pill" :color="billingYearly ? 'plusGreen' : 'plusGreenAccent3'"
              :text-color="billingYearly ? 'plusGreyDarken4' : 'plusGreenDarken4'" label x-small>
              {{ $t("message.admin_plus_upgrade_discount_badge") }}
            </v-chip>
          </v-btn>
        </div>
      </div>

      <v-sheet rounded class="d-flex align-center pa-4 mb-8 justify-center sheet-banner">
        <v-icon color="primary" class="mr-3 mt-1 align-self-center">mdi-tag-multiple-outline</v-icon>
        <div class="d-flex flex-column">
          <span class="font-roboto font-weight-medium plusGreyDarken4--text">
            {{ $t("message.admin_plus_upgrade_banner_title") }}
          </span>
          <span class="font-roboto text-body-2 plusGreyDarken1--text">
            {{ " " }}{{ $t("message.admin_plus_upgrade_banner_subtitle") }}
          </span>
        </div>
      </v-sheet>


      <v-row>
        <v-col cols="12" md="6">
          <v-card class="plan-card plan-card--black fill-height d-flex flex-column px-13 py-10" dark flat
            color="plusGreyDarken4">

            <div class="plan-badges">
              <v-chip class="font-roboto font-weight-bold rounded-l-md rounded-r-0" color="plusGreyLighten5"
                text-color="plusGreyDarken4" label small>
                {{ $t("message.admin_plus_upgrade_recommended") }}
              </v-chip>
              <v-chip class="font-roboto font-weight-bold rounded-l-0 rounded-r-md" color="plusGreenAccent3"
                text-color="plusGreyDarken4" label small>
                {{ $t("message.admin_plus_upgrade_save_amount") }}
              </v-chip>
            </div>

            <v-card-text class="pt-10 pb-2 flex-grow-1 d-flex flex-column">

              <div class="font-roboto text-h4 font-weight-bold mb-1 plusTextOnSecondary--text">
                {{ $t("message.admin_plus_upgrade_plan_black") }}
              </div>
              <div class="d-flex align-baseline flex-wrap mb-1 plusTextOnSecondary--text ">
                <span class="font-roboto text-h3 font-weight-bold">${{ displayPriceBlack }}</span>
              </div>
              <div class="font-roboto text-body-2 plusGreyLighten2--text mb-3">
                <!-- {{ blackBillingNote }} -->
                Billed monthly, plus 1% service fee
              </div>
              <div class="font-roboto text-body-2 plusGreenAccent3--text mb-4 d-flex align-center">
                <v-icon small color="plusGreenAccent3" class="mr-1">mdi-tag-multiple-outline</v-icon>
                {{ $t("message.admin_plus_upgrade_save_annual_line") }}
              </div>
              <div class="dashed-rule dashed-rule--on-dark mb-4" />
              <ul class="feature-list pl-0 mb-6">
                <li v-for="key in featureKeys" :key="key" class="d-flex align-center justify-start mb-2">
                  <v-icon color="plusGreenAccent3" size="20" class="mr-2 mt-0">mdi-check-circle</v-icon>
                  <span class="font-roboto text-body-1 plusTextOnSecondary--text">{{ $t(key) }}</span>
                </li>
              </ul>
              <v-btn block x-large depressed color="plusGrey40"
                class="font-roboto font-weight-medium cta-black-plan text-uppercase mt-auto"
                @click="onSelectPlan('black')">
                {{ $t("message.admin_plus_upgrade_cta_black") }}
              </v-btn>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" md="6">
          <v-card class="plan-card plan-card--coral fill-height d-flex flex-column px-13 py-10" outlined
            color="plusSurface">
            <v-card-text class="pt-8 pb-2 flex-grow-1 d-flex flex-column">
              <div class="font-roboto text-h4 font-weight-bold plusGreyDarken4--text mb-1">
                {{ $t("message.admin_plus_upgrade_plan_coral") }}
              </div>
              <div class="d-flex align-baseline flex-wrap mb-1">
                <span class="font-roboto text-h3 font-weight-bold plusGreyDarken4--text">${{ displayPriceCoral }}</span>

              </div>
              <div class="font-roboto text-body-2  plusGreyDarken1--text mb-3">
                <!-- {{ coralBillingNote }} -->
                billed monthly, no service fee
              </div>
              <div class="font-roboto text-body-2 plusGreenAccent4--text mb-4 d-flex align-center">
                <v-icon small color="plusGreenAccent4" class="mr-1">mdi-tag-outline</v-icon>
                {{ $t("message.admin_plus_upgrade_save_annual_line") }}
              </div>
              <div class="dashed-rule mb-4"></div>
              <ul class="feature-list pl-0 mb-6">
                <li v-for="key in featureKeys" :key="'c-' + key" class="d-flex align-center justify-start  mb-2">
                  <v-icon color="plusGreenAccent4" size="20" class="mr-2 mt-0">mdi-check-circle</v-icon>
                  <span class="font-roboto text-body-1 plusGreyDarken3--text">{{ $t(key) }}</span>
                </li>
              </ul>
              <v-btn block x-large outlined color="plusGreyDarken4"
                class="font-roboto font-weight-medium plusGrey40 mt-auto text-uppercase" @click="onSelectPlan('coral')">
                {{ $t("message.admin_plus_upgrade_cta_coral") }}
              </v-btn>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
const BLACK_MONTHLY = 49;
const CORAL_MONTHLY = 149;
const YEARLY_DISCOUNT = 0.9;

export default {
  name: "ViewUpgradePlanAdminPlus",
  data() {
    return {
      billingYearly: true,
      featureKeys: [
        "message.admin_plus_upgrade_feature_unlimited_students",
        "message.admin_plus_upgrade_feature_payments",
        "message.admin_plus_upgrade_feature_attendance",
        "message.admin_plus_upgrade_feature_student_data",
        "message.admin_plus_upgrade_feature_automations",
        "message.admin_plus_upgrade_feature_engagement",
        "message.admin_plus_upgrade_feature_lms",
        "message.admin_plus_upgrade_feature_marketing",
        "message.admin_plus_upgrade_feature_leads",
      ],
    };
  },
  computed: {
    trialEndDate() {
      const raw = this.$store.state.academyAdminStatus?.subscriptionEndsAt;
      if (!raw) return null;
      const d = new Date(raw);
      if (Number.isNaN(d.getTime())) return null;
      return d;
    },
    trialEndFormatted() {
      if (!this.trialEndDate) return null;
      try {
        return this.$d(this.trialEndDate, "month_day_year", this.$i18n.locale);
      } catch {
        return null;
      }
    },
    planSubtitle() {
      if (this.trialEndFormatted) {
        return this.$t("message.admin_plus_upgrade_subtitle_with_date", {
          date: this.trialEndFormatted,
        });
      }
      return this.$t("message.admin_plus_upgrade_subtitle_fallback");
    },
    displayPriceBlack() {
      const n = this.billingYearly
        ? Math.round(BLACK_MONTHLY * YEARLY_DISCOUNT)
        : BLACK_MONTHLY;
      console.log(n);
      return BLACK_MONTHLY;
    },
    displayPriceCoral() {
      const n = this.billingYearly
        ? Math.round(CORAL_MONTHLY * YEARLY_DISCOUNT)
        : CORAL_MONTHLY;

      console.log(n);
      return CORAL_MONTHLY;
    },
    blackBillingNote() {
      return this.billingYearly
        ? this.$t("message.admin_plus_upgrade_black_billed_yearly")
        : this.$t("message.admin_plus_upgrade_black_billed_monthly");
    },
    coralBillingNote() {
      return this.billingYearly
        ? this.$t("message.admin_plus_upgrade_coral_billed_yearly")
        : this.$t("message.admin_plus_upgrade_coral_billed_monthly");
    },
  },
  methods: {
    /** @param {'black' | 'coral'} plan */
    onSelectPlan(plan) {
      void plan;
      // TODO: wire checkout or billing flow when API is available
    },
  },
};
</script>

<style scoped>
.header-container {
  border-bottom: 1px solid var(--grey-lighten-2, #E0E0E0);
}

.upgrade-plan-page {
  min-height: 100%;
  background-color: var(--v-plusBackground-base, #fafafa);
}

.billing-pill {
  border: 1px solid var(--v-plusBorder-base, #e0e0e0);
  overflow: hidden;
  background: var(--v-plusSurface-base, #fff);
  box-shadow: 0 10px 20px 0 rgba(13, 13, 13, 0.15);
}

.billing-pill-btn {
  text-transform: none;
  letter-spacing: normal;
  min-height: 44px !important;
  color: #757575 !important;
  background-color: transparent !important;
  box-shadow: none !important;
}

.billing-pill-btn--active {
  background-color: var(--v-plusGreyDarken4-base, #212121) !important;
  color: #fff !important;
}

.plan-card {
  border-radius: 12px;
}

.plan-card--black {
  position: relative;
  overflow: visible;
}

.plan-card--coral {
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.10), 0 4px 6px -4px rgba(0, 0, 0, 0.10);
  border: 1px solid var(--grey-lighten-2, #E0E0E0);

}

.plan-badges {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 10px 15px 15px rgba(0, 0, 0, 0.10), 0 4px 6px -4px rgba(0, 0, 0, 0.10);

}

.feature-list {
  list-style: none;
}

.dashed-rule {
  border-top: 1px dashed rgba(0, 0, 0, 0.12);
}

.dashed-rule--on-dark {
  border-top-color: rgba(255, 255, 255, 0.28);
}

.cta-black-plan {
  color: #000 !important;
}

.sheet-banner {
  background: linear-gradient(90deg, #B9F6CA 0%, #FFF 100%);
}
</style>
